<template lang="pug">
  .header__logo
    router-link(:to="{name:'Home'}")
      img.img-fluid(src='/assets/images/logo.svg' alt='')
</template>

<script type="text/javascript">
export default {
  name: "Logo",
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss"></style>
